import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PatientActions } from 'src/redux/actions/constant';

import patientService from 'src/services/apiServices/patientService';

const {
  FAILURE_DEACTIVATE_PATIENT,
  SUCCESS_DEACTIVATE_PATIENT,
  LOADING_DEACTIVATE_PATIENT,
  REQUEST_DEACTIVATE_PATIENT,
} = PatientActions;

function* deactivatePatients(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_DEACTIVATE_PATIENT });
    const response = yield call(patientService.deactivatePatient, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_DEACTIVATE_PATIENT, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_DEACTIVATE_PATIENT, payload: error });
  }
}

function* deactivatePatientsSaga() {
  yield takeEvery(REQUEST_DEACTIVATE_PATIENT, deactivatePatients);
}

export default deactivatePatientsSaga;
